module.exports = __webpack_public_path__ + "4896587a6689b165ce60cf3a07d02c75.png";